// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nkdE5","button":"styles_button__c5uSq","buttonTitle":"styles_buttonTitle__uipDK","buttonText":"styles_buttonText__pkLam"};